import Pagination from '@/components/pagination/index.vue';
import componentsDetail from './details/index.vue';
import Service from './service';
import Financing from './financing/index.vue';
import Cooperate from './cooperate/index.vue';
import Information from './Information/index.vue';
export default {
  components: {
    Pagination,
    componentsDetail,
    Financing,
    Cooperate,
    Information
  },
  data() {
    return {
      yhxs: null,
      getEffectiveCountnum: 0,
      productList: [],
      bankInfoArr: [],
      selBankId: null,
      total: 0,
      Id: null,
      query: {
        pageNum: 1,
        pageSize: 6,
        brandId: '',
        cateCode: '',
        orderColumn: ''
      },
      bankList: [
        {
          id: '1',
          type: '1',
          bankIcon: require('@/assets/temp/bank-ms.png'),
          bankBg: require('@/assets/temp/bank1-bg.png'),
          bankName: '蒙商银行',
          typeName: '兴农e贷',
          typeTips: '蒙商银行向从事农林牧渔业生产、加工、制造、流通、服务等经营活动主体发放的经营性信贷业务。',
          maxPrice: '500',
          typeDate: '最长期限3年',
          typeRate: '4.35%',
          limit: '最高贷款额度',
          unit: '万'
        }, {
          id: '2',
          type: '1',
          bankIcon: require('@/assets/temp/bank-ms.png'),
          bankBg: require('@/assets/temp/bank1-bg.png'),
          bankName: '蒙商银行',
          typeName: '惠农e贷',
          typeTips: '蒙商银行向符合蒙商银行准入基本条件的农户给予授信的信贷业务。',
          maxPrice: '30',
          typeDate: '最长期限3年',
          typeRate: '4.35%',
          limit: '最高贷款额度',
          unit: '万'
        }, {
          id: '3',
          type: '1',
          bankIcon: require('@/assets/temp/bank-js.png'),
          bankBg: require('@/assets/temp/bank2-bg.png'),
          bankName: '中国建设银行',
          typeName: '裕农快贷抵押贷',
          typeTips: '实时获知贷款额度，线上办理，自主支用',
          maxPrice: '0.1-100',
          typeDate: '12个月',
          typeRate: '3.85%',
          limit: '贷款额度',
          unit: '万'
        }, {
          id: '4',
          type: '1',
          bankIcon: require('@/assets/temp/bank-js.png'),
          bankBg: require('@/assets/temp/bank2-bg.png'),
          bankName: '中国建设银行',
          typeName: '裕农快贷信用版',
          typeTips: '实时获知贷款额度，全流程线上办理，自主支用，纯信用贷款，在贷款额度和期限内可循环使用',
          maxPrice: '0.1-50',
          typeDate: '12-60月',
          typeRate: '4.25%',
          limit: '贷款额度',
          unit: '万'
        }, {
          id: '5',
          type: '2',
          bankIcon: require('@/assets/temp/BOC.png'),
          bankBg: require('@/assets/temp/bank3-bg.png'),
          bankName: '中国银行',
          typeName: '种植贷',
          typeTips: '针对自有土地且种植经验满2年的个体农户推出的授信业务。',
          maxPrice: '10-300',
          typeDate: '最长3年',
          typeRate: '3.45%-4.1%',
          limit: '贷款额度',
          unit: '万'
        }, {
          id: '6',
          type: '2',
          bankIcon: require('@/assets/temp/BOC.png'),
          bankBg: require('@/assets/temp/bank3-bg.png'),
          bankName: '中国银行',
          typeName: '商户贷',
          typeTips: '针对民生服务类经营满一年的个体工商户和小微企业主推出的授信业务，小微企业主为经营实体的法人代表。',
          maxPrice: '100',
          typeDate: '最长1年',
          typeRate: '3.05%-3.90%',
          limit: '最高贷款额度',
          unit: '万'
        }
      ],
      dialogVisible: false,
      detailId: null,
      type: null,
      total1: 0,
      tId: '66aaf74f247b9fffdb5eba08',
      total2: 0
    };
  },
  created() {
    this.getProductList();
    this.allProductList = Object.values(this.productList).flat();
    this.getEffectiveCount();
    this.application();

  },
  methods: {
    changeTabIndex(item) {
      // console.log(item);
      this.selBankId = item.fund;
      this.Id = this.selBankId;

      console.log(this.selBankId);
    },
    // 展示所有银行的所有产品
    selectAllBanks() {
      this.selBankId = null; // 设置为null表示展示所有银行的产品
      this.Id = this.selBankId;
    },
    getProductList(page) {
      if (page) {
        this.query.pageNum = page.pageNo;
        this.query.pageSize = 8;
      } else {
        this.query.pageNum = 1;
      }
      Service.getProductList({ homePage: 10, limit: 100 }).then(res => {
        if (res.result) res.result.forEach(item => {
          if (!Object.keys(this.productList).includes(item.fund.fund)) {
            this.productList[item.fund.fund] = [item];
            this.bankInfoArr.push(item.fund);

          }
          else this.productList[item.fund.fund].push(item);
          // console.log(res, '2222');
        });
        this.selBankId = this.bankInfoArr[0].fund;
        this.allProductList = Object.values(this.productList).flat();  // 更新所有银行产品
        this.total1 = res.total;
      });
      // console.log(this.productList,'2222');
      // console.log(this.selBankId,'111');
    },
    toDetails(item) {
      // this.detailId = item.id;
      // this.type = item.type;
      // this.dialogVisible = true;
      this.$router.push({
        path: '/finance-insurance/details',
        query: {
          id: item._id
        }
      });
    },

    toPage(url) {
      if (url) {
        this.$router.push(url);
      }
    },

    close() {
      this.dialogVisible = false;
    },
    // showScroll() {
    //   this.$el.querySelector('.finance-right').style.overflowY = 'auto'; // 鼠标进入显示滚动条
    // },
    // hideScroll() {
    //   this.$el.querySelector('.finance-right').style.overflowY = 'hidden'; // 鼠标离开隐藏滚动条
    // },
    handClick(item) {
      this.$router.push(item);
    },
    getEffectiveCount() {
      // Service.getEffectiveCount
      Service.getEffectiveCount().then(res => {

        // console.log(res, '22222');
        this.getEffectiveCountnum = res.data;
        // this. total1=res. total;
      });
    },
    application() {
      Service.application().then(res => {
        // console.log(res, '222');
        this.total2=res.result;
      });
    }
  }
};
